import React, { useCallback, useEffect } from "react";

import * as strings from "../../../strings";
import * as UserUtils from "../../../lib/util/UserUtils";
import * as AnalyticsUtils from "../../../lib/util/AnalyticsUtils";
import * as UserActions from "../../../store/User/User.action";
import * as UserSelectors from "../../../store/User/User.selector";
import * as Api from "../../../Api";

import PortalPrivacy from "../../../views/Legal/PortalPrivacy";
import Button from "../../common/Button/Button";
import Modal from "../../container/Modal/Modal";
import { StoreState } from "../../../store/RootReducer";
import { useDispatch, useSelector } from "../../../lib/hook/ReduxHooks";

const PrivacyModal = () => {
	const { loggedInUser } = useSelector((state: StoreState) => ({
		loggedInUser: UserSelectors.selectLoggedInUser(state),
	}));

	const dispatch = useDispatch();

	const updateTerms = useCallback(() => {
		try {
			const { uid, params } = loggedInUser || {};
			if (!uid) {
				throw new Error("Missing user id");
			}

			Api.postUserUpdate.submit({
				params: { userId: uid },
				body: {
					portalTermsVersionAccepted: params.portalTermsConditionsVersion,
				},
			});

			dispatch(
				UserActions.updateUserObject({
					portalTermsVersionAccepted: params.portalTermsConditionsVersion,
				}),
			);

			AnalyticsUtils.sendEvent({
				eventCategory: "Terms",
				eventAction: "accept",
				mixpanelProperties: {
					name: "Accept Terms",
				},
			});
		} catch (error) {
			console.error(error);
		}
	}, [loggedInUser, dispatch]);

	const privacyAccepted = UserUtils.isUserTermsAccepted(loggedInUser);

	useEffect(() => {
		if (privacyAccepted) {
			return;
		}

		AnalyticsUtils.sendEvent({
			eventCategory: "Terms",
			eventAction: "show",
			mixpanelProperties: {
				name: "Show Terms",
			},
		});
	}, [privacyAccepted]);

	return (
		<Modal
			visible={!privacyAccepted}
			className={"Legal__modal Legal__modal--privacy"}
			closeOnEsc={false}
			closeMaskOnClick={false}
			showCloseButton={false}
		>
			<PortalPrivacy modal={true}>
				<Button disabled={privacyAccepted} onClick={updateTerms}>
					{strings.MISC_ACCEPT}
				</Button>
			</PortalPrivacy>
		</Modal>
	);
};

export default PrivacyModal;
